const iconBase = 'http://maps.google.com/mapfiles/ms/icons/';

const iconLinks = {
    unlisted: iconBase + 'red-dot.png',
    topFiftyNineCanada: iconBase + 'pink-dot.png',
    topHundredCanada: iconBase + 'orange-dot.png',
    topHundredPublicNorthAmerica: iconBase + 'green-dot.png',
    topHundredWorld: iconBase + 'blue-dot.png',
};

export default iconLinks;